import PluginBefore from './before'
import PluginAfter from './after'

export const VueSitecoreMixin = PluginBefore
export const SitecoreExtend = PluginAfter
